import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './App.css';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import NuevaSesion from './pages/NuevaSesion';
import Sesion from './pages/Sesion';
import Feedback from './pages/Feedback';
import Historial from './pages/Historial';
import Estadisticas from './pages/Estadisticas';
import Perfil from './pages/Perfil';
import Consenso from './pages/Consenso';
import Admin from './pages/Admin';
import AdminImages from './pages/AdminImages';

// Components
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';

// Context
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-[hsl(232,36%,7%)]">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Protected routes */}
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/nueva-sesion" element={<NuevaSesion />} />
              <Route path="/sesion/:id" element={<Sesion />} />
              <Route path="/sesion/:id/feedback" element={<Feedback />} />
              <Route path="/historial" element={<Historial />} />
              <Route path="/estadisticas" element={<Estadisticas />} />
              <Route path="/perfil" element={<Perfil />} />
              <Route path="/consenso" element={<Consenso />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/images" element={<AdminImages />} />
            </Route>
            
            {/* Redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: 'hsl(232, 36%, 12%)',
                border: '1px solid hsl(232, 18%, 22%)',
                color: 'hsl(220, 35%, 96%)'
              }
            }}
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
